import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export const UnifiedCheckoutPaymentOption = ({
  selected,
  visible,
  trigger,
  children,
  onSelect,
}: {
  selected: boolean;
  visible: boolean;
  trigger: ReactNode;
  children?: ReactNode;
  onSelect: () => void;
}) =>
  visible ? (
    <div
      className={twMerge(
        "overflow-hidden rounded-2xl border border-zinc-200 bg-white transition-shadow hover:shadow-md",
        selected &&
          "border-[#D1A7E9] shadow-[2px_2px_16px_rgba(209,167,233,0.1)]",
      )}
    >
      <button
        type="button"
        aria-expanded={selected}
        onClick={onSelect}
        className={twMerge(
          "w-full cursor-pointer p-4 text-left text-sm focus-visible:outline-2 focus-visible:outline-offset-[-3px] focus-visible:outline-purple-600",
          selected && "pb-2",
        )}
      >
        {trigger}
      </button>
      {selected && (
        <div className="flex flex-col gap-2 px-4 pb-4 text-sm">{children}</div>
      )}
    </div>
  ) : null;
